module.exports = __webpack_public_path__ + "img/contacttwo (1).8a938dea.png";